'use client';

export { default } from './Fab';
export { default as fabClasses } from './fabClasses';
export * from './fabClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Fab/index.js
// module id = 329
// module chunks = 25